import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, byId } from './helpers/utility';





authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert








const bannerLinkInput = byId('bannerLinkInput');
const onClickLinkInput = byId('onClickLinkInput');
const carouselsTableBodyElement = byId('carouselsTableBodyElement');
const carouselsTableNoDataRowElement = byId('carouselsTableNoDataRowElement');
const carouselsDataFun = {
    addNew: {
        submit: async () => {



            try {
                const data = {

                    bannerLink: bannerLinkInput.value,
                    onClickLink: onClickLinkInput.value,

                };
                const response = await callTheApServerPost(`/basic/addNewCarousel`, { data: data });
                axiosResponseHandler(response);
                const res = response.data;






                if (res.status === 'success') {
                    console.log(res);


                    Swal.fire({
                        title: 'New Carousel added',
                        icon: 'success',
                        showConfirmButton: false,


                        allowOutsideClick: false,


                    });

                    setTimeout(() => {
                        location.reload();
                    }, 3000);



                }
            } catch (error) {
                axiosErrorHandler(error);
                console.log(error);
            }
        }
    },
    delete: async ({ sn }) => {


        try {
            const response = await callTheApServerGet(`/basic/deleteCarousel/${sn}`);
            axiosResponseHandler(response);
            const res = response.data;

            if (res.status === 'success') {
                console.log(res);


                Swal.fire({
                    title: 'Carousel Deleted',
                    icon: 'success',
                    showConfirmButton: false,


                    allowOutsideClick: false,


                });

                setTimeout(() => {
                    location.reload();
                }, 3000);



            }
        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }

    },
    get: async () => {


        try {
            const response = await callTheApServerGet(`/basic/getCarousels`);
            axiosResponseHandler(response);
            const res = response.data;






            if (res.status === 'success') {
                console.log(res);




                if (res.carouselData.length > 0) {

                    addDNoneClass(carouselsTableNoDataRowElement, true);

                    let i = 0;
                    while (i < res.carouselData.length) {
                        const { sn, bannerLink, onClickLink } = res.carouselData[i];

                        carouselsTableBodyElement.innerHTML +=`
                        <tr>
                        
                            <td>${i + 1}</td>
                           <td> <img class="img-fluid" src="${bannerLink}" alt="Game Banner" width="200"></td>
                            <td>${onClickLink}</td>
                         
                            <td><button class="btn btn-danger" onclick="carouselsDataFun.delete(${JSON.stringify({ sn }).split('"').join('&quot;')})" >Delete</button></td>
                          
                        </tr>
                        `;
                        i++;
                    }
                } else {
                    carouselsTableNoDataRowElement.innerHTML = `
                    <th class='text-center' colspan='4'>No Carousels Found 😥</th> 
                    `;
                }





            }

        } catch (error) {
            axiosErrorHandler(error);
            console.log(error);
        }
    }
};

window.carouselsDataFun = carouselsDataFun;

carouselsDataFun.get();
